<ng-container *ngIf="fitnessTrackersList$ | async as fitnessTrackersList">
  <ng-container *ngIf="fitnessTrackersList.length > 0">
    <div class="fitness-tracker-card border rounded bg-white p-3">
      <div class="fitness-tracker-card-header bg-white">
        <h2 class="fitness-tracker-card-header-title font-size-18 mt-0">{{ 'fitness.tracker.card.heading' | translate }}</h2>
        <div class="fitness-tracker-card-header-desc font-size-14">{{ 'fitness.tracker.card.subheading' | translate }}</div>
      </div>
      <ng-container *ngFor="let fitnessTracker of fitnessTrackersList">
        <ng-container *ngIf="fitnessTracker.HasConnection; else notConnectedTracker">
          <div class="fitness-tracker-card-body border rounded mt-4 p-3">
            <ng-container *ngTemplateOutlet="fitnessTrackerLogo; context: { $implicit: fitnessTracker }"></ng-container>
            <div class="d-flex align-items-center justify-content-between mt-3">
              <div class="d-flex align-items-center">
                <img class="connected-person rounded-circle" [src]="fitnessTracker.Image | cardTypeImageUrl" alt="" />
                <div class="ms-2">
                  <div class="font-size-14 mb-2">
                    {{ 'fitness.tracker.connected.to.id' | translate }}{{ fitnessTracker.UserId }}
                  </div>
                  <div class="text-success font-size-14">
                    {{ 'fitness.tracker.connected.text' | translate }} {{ providers[fitnessTracker.ProviderId] }}
                  </div>
                </div>
              </div>
              <div (click)="removeFitnessTracker(fitnessTracker.ProviderId)">
                <span class="material-symbols-outlined cursor-pointer text-danger">delete</span>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #notConnectedTracker>
          <div class="fitness-tracker-card-body unconnected border rounded mt-4 px-3">
            <div class="d-flex align-items-center justify-content-between h-100">
              <ng-container *ngTemplateOutlet="fitnessTrackerLogo; context: { $implicit: fitnessTracker }"></ng-container>
              <div
                class="d-flex align-items-center cursor-pointer mt-1"
                (click)="connectFitnessTracker(fitnessTracker.ProviderId)"
              >
                <div class="font-size-14">
                  {{ 'fitness.tracker.connect.text' | translate }} {{ providers[fitnessTracker.ProviderId] }}
                </div>
                <span class="material-symbols-outlined">chevron_right</span>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #fitnessTrackerLogo let-fitnessTracker>
  <div class="fitness-tracker-logo">
    <img
      class="w-100"
      [src]="'fitness-tracker/' + providers[fitnessTracker.ProviderId] + '.svg' | lowercase | contentAssetImage"
    />
  </div>
</ng-template>
